export default "__VITE_ASSET__CBPFw5jl__";